import React, { useState } from 'react';
import { useConfig } from '../context/ConfigContext';

const Header = ({ pageKey, title, subtitle, subtitleType = 'text', subtitleImage }) => {
    const [cacheBuster] = useState(() => Date.now());
    const getCleanImageUrl = (url) => {
        if (!url) return '';
        return `${url}${url.includes('?') ? '&' : '?'}v=${cacheBuster}`;
    };

    const { config } = useConfig();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    React.useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const pageDesign = config?.pageDesigns?.[pageKey] || {};
    const secondaryColor = config?.secondaryColor || '#ff5874';
    const fontColor = pageDesign.globalFontColor || config?.globalFontColor || '#ffffff';

    const logoSrc = isMobile
        ? (pageDesign?.headerTitleUrl || pageDesign?.headerLogoUrl || config?.logoMobileUrl || config?.logoUrl || config?.headerLogoUrl || config?.headerTitleUrl)
        : (pageDesign?.headerTitleUrl || pageDesign?.headerLogoUrl || config?.logoUrl || config?.logoMobileUrl || config?.headerLogoUrl || config?.headerTitleUrl);

    const displayTitle = title || pageDesign.title;
    const displaySubtitle = subtitle || pageDesign.subtitle;

    return (
        <header className="relative w-full z-10 flex-shrink-0 flex flex-col items-center pt-4 pb-2 px-4 select-none">
            <div className="relative w-full max-w-xl flex flex-col items-center">
                {logoSrc && (
                    <div className="text-center animate-fadeIn max-w-xs sm:max-w-md mx-auto mb-2">
                        <img
                            src={getCleanImageUrl(logoSrc)}
                            alt="Logo"
                            className="w-full h-auto max-h-24 object-contain mx-auto drop-shadow-md"
                        />
                    </div>
                )}

                {(displayTitle || displaySubtitle || (subtitleType === 'image' && subtitleImage)) && (
                    <div className="text-center animate-fadeIn">
                        {displayTitle && (
                            <h2
                                className="text-2xl sm:text-3xl font-black capitalize tracking-wider"
                                style={{ color: secondaryColor }}
                            >
                                {displayTitle}
                            </h2>
                        )}

                        {subtitleType === 'image' && subtitleImage ? (
                            <div className="mt-2 max-w-[250px] mx-auto">
                                <img
                                    src={getCleanImageUrl(subtitleImage)}
                                    alt="Subtitle"
                                    className="w-full h-auto object-contain max-h-[80px]"
                                />
                            </div>
                        ) : (
                            displaySubtitle && (
                                <div className="mt-1">
                                    <p
                                        className="text-xs sm:text-sm font-bold capitalize tracking-widest"
                                        style={{ color: fontColor }}
                                    >
                                        {displaySubtitle}
                                    </p>
                                </div>
                            )
                        )}
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
